module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921020834_T.3b8518cb.jpg";